/* eslint-disable react/display-name */
import NCAdClassed from 'shared-components/nc/NCAdClassed'
import clsx from 'clsx'
import NCPostsList from 'nc/NCPostsList'
import NCRecommend from 'nc/NCRecommend'
import dynamic from 'next/dynamic'
import { CSSProperties } from 'react'
import { componentMapper } from 'shared-code/component'
import NCAd from 'shared-components/nc/NCAd'
import NCAffilateSection from 'shared-components/nc/NCAffilateSection'
import NCPoll from 'shared-components/nc/NCPoll'
import NCAlert from 'shared-components/nc/NCAlert'
import NCBestProductGallery from 'shared-components/nc/NCBestProductGallery'
import NCColumns from 'shared-components/nc/NCColumns'
import NCTabs from 'shared-components/nc/NCTabs'
import NCDealsButton from 'shared-components/nc/NCDealsButton'
import NCDealsDetailed from 'shared-components/nc/NCDealsDetailed'
// import NCBestProductTitle from 'shared-components/nc/NCBestProductTitle'
import NCApp from 'shared-components/nc/NCApp'
import NCAudioChart from 'shared-components/nc/NCAudioChart'
import NCDealsLatest from 'shared-components/nc/NCDealsLatest'
import NCDealsMedium from 'shared-components/nc/NCDealsMedium'
import NCDealsMediumCarousel from 'shared-components/nc/NCDealsMediumCarousel'
import NCDealsSimple from 'shared-components/nc/NCDealsSimple'
import NCDisclosureBox from 'shared-components/nc/NCDisclosureBox'
import NCExpandableImg from 'shared-components/nc/NCExpandableImg'
import NCFaq from 'shared-components/nc/NCFaq'
import NCGallery from 'shared-components/nc/NCGallery'
import NCImg from 'shared-components/nc/NCImg'
import NCImgComparison from 'shared-components/nc/NCImgComparison'
import NCLinkedImg from 'shared-components/nc/NCLinkedImg'
import NCMulti from 'shared-components/nc/NCMulti'
import NCNewsTitle from 'shared-components/nc/NCNewsTitle'
import NCOpinion from 'shared-components/nc/NCOpinion'
import NCPre from 'shared-components/nc/NCPre'
import NCPromoted from 'shared-components/nc/NCPromoted'
import NCQuote from 'shared-components/nc/NCQuote'
import NCScript from 'shared-components/nc/NCScript'
import NCSection from 'shared-components/nc/NCSection'
import NCSeeAlso from 'shared-components/nc/NCSeeAlso'
import NCSpecTable from 'shared-components/nc/NCSpecTable'
import NCString from 'shared-components/nc/NCString'
import NCSeparator from 'shared-components/nc/NCSeparator'
import NCTable from 'shared-components/nc/NCTable'
import NCTldr from 'shared-components/nc/NCTldr'
import NCWebSourcesSummary from 'shared-components/nc/NCWebSourcesSummary'
import NCTwitter from 'shared-components/nc/NCTwitter'
import NCUnsafeHtml from 'shared-components/nc/NCUnsafeHtml'
import NCEmbedYoutube from 'shared-components/nc/NCEmbedYoutube'
import NCLazy from 'shared-components/service/NCLazy'
import GuideCapture from 'components/owner-notes/guide/GuideCapture'
import GuidePick from 'components/owner-notes/guide/GuidePick'
import GuideRailAsk from 'components/owner-notes/guide/GuideRailAsk'
import styleUtils from 'shared-components/styles/util.module.css'
import { MapDiscriminatedComponent } from 'shared-definitions/types'
import { DSNCSG } from 'types.sg.ds'
import { getds } from '../ds'
import styles from './NC.module.css'
import NCTrustUs from 'shared-components/nc/NCTrustUs'
import NCAboutExpert from 'shared-components/nc/NCAboutExpert'
import NCBestListSection from 'shared-components/nc/NCBestListSection'
import NCError from 'shared-components/nc/NCError'
import { publicConfig } from '../config'
import NCAuthorOpinion from 'shared-components/nc/NCAuthorOpinion'
import NCDisclaimerBox from 'shared-components/nc/NCDisclaimerBox'
import NCAudioChartsNext from 'shared-components/nc/NCAudioChartsNext'
import NCDealHuntSlider from 'shared-components/nc/NCDealHuntSlider'
import NCDealsLargeAlt from 'shared-components/nc/NCDealsLargeAlt'
import NCDealsLargeSG from 'nc/NCDealsLargeSG'
import NCCollapsedBox from 'shared-components/nc/NCCollapsedBox'

const NCCarousel = dynamic(() => import('shared-components/nc/NCCarousel'), { ssr: false })
const NCLinkedButtons = dynamic(() => import('shared-components/nc/NCLinkedButtons'), {
  ssr: false,
})
const NCEmbedTiktok = dynamic(() => import('shared-components/nc/NCEmbedTiktok'), { ssr: false })
const NCAudio = dynamic(() => import('shared-components/nc/NCAudio'), { ssr: false })
const NCMorePosts = dynamic(() => import('shared-components/nc/NCMorePosts'), { ssr: false })
const NCDealsSlider = dynamic(() => import('shared-components/nc/NCDealsSlider'), { ssr: false })
const NCVideoLinks = dynamic(() => import('shared-components/nc/NCVideoLinks'), { ssr: false })
const NCVideoSlider = dynamic(() => import('shared-components/nc/NCVideoSlider'), { ssr: false })
const NCVideo = dynamic(() => import('shared-components/nc/NCVideo'), { ssr: false })
const NCFeedback = dynamic(() => import('nc/NCFeedback'), { ssr: false })
const NCNewsletter = dynamic(() => import('nc/NCNewsletter'), { ssr: false })
const NCFaqSubmission = dynamic(() => import('nc/NCFaqSubmission'), { ssr: false })
const NCDealHunt = dynamic(() => import('shared-components/nc/NCDealHunt'), { ssr: false })
// Have your say (2026-10-27): the end-of-article poll sets, in "You might like"'s place. Client
// only (the sets come from WordPress, edge-cached), but mounted at hydration, NOT on scroll: the
// reader must find it ready when they reach the end of the article (Guillaume, 2026-10-27), and
// one small request per article view is the price. The page's own polls are already in the body.
const NCHaveYourSay = dynamic(() => import('nc/NCHaveYourSay'), { ssr: false })

const map: MapDiscriminatedComponent<DSNCSG, 'resource'> = {
  'nc-web-sources-summary': NCWebSourcesSummary,
  'nc-deal-hunt-slider': NCDealHuntSlider,
  'nc-deal-hunt': feed => (
    <NCLazy
      className={clsx(styles.dealhuntArticleLazy, styleUtils.nc)}
      component={NCDealHunt}
      props={feed}
      layout="raw"
    />
  ),
  'nc-deals-large-alt': NCDealsLargeAlt,
  'nc-collapsed-box': NCCollapsedBox,
  'nc-disclaimer-box': NCDisclaimerBox,
  'nc-engagement-starter': null, // the featured comment lives in the conversation panel (2026-10-24)
  'nc-video-links': feed => (
    <NCLazy
      component={NCVideoLinks}
      props={feed}
      layout="raw"
      className={clsx(styleUtils.nc, styles.moreLazyHome)}
    />
  ),
  'nc-error': NCError,
  'nc-author-opinion': NCAuthorOpinion,
  'nc-unsafe-html': NCUnsafeHtml,
  'nc-separator': NCSeparator,
  'nc-app': NCApp,
  'nc-news-title': NCNewsTitle,
  'nc-recommend': NCRecommend,
  'nc-have-your-say': feed => <NCHaveYourSay data={feed.data} />,
  'nc-spec-table': NCSpecTable,
  'nc-disclosure-box': NCDisclosureBox,
  'nc-revcontent': feed => (
    <NCAdClassed
      {...{
        ...feed,
        data: { type: 'plain', resource: 'nc-ad-classed', visible: 'all', className: '' },
      }}
    />
  ),
  'nc-best-product-title': null, // it was deliberately hidden
  'nc-best-product-gallery': NCBestProductGallery,
  'nc-faq-submission': feed => (
    <NCLazy
      layout="raw"
      component={NCFaqSubmission}
      props={feed}
      className={clsx(styles.faqFeedbackLazy, styleUtils.nc)}
    />
  ),
  'nc-sponsored': NCMulti,
  'nc-faq': NCFaq,
  'nc-twitter': NCTwitter,
  'nc-affilate-section': NCAffilateSection,
  'nc-deals-button': NCDealsButton,
  'nc-deals-simple': NCDealsSimple,
  'nc-deals-detailed': NCDealsDetailed,
  // Owner notes on a best-list article (docs/owner-notes-guide-funnel-plan.md). Server-rendered
  // (visitor-invariant: the line, the Owners block); declared / own state hydrates client-side.
  'nc-owner-guide-capture': GuideCapture,
  'nc-owner-guide-pick': GuidePick,
  'nc-owner-guide-rail': GuideRailAsk,
  'nc-deals-slider': feed => (
    <NCLazy
      layout="raw"
      component={NCDealsSlider}
      props={feed}
      className={clsx(styles.dealsSliderLazy, styleUtils.nc)}
    />
  ),
  'nc-deals-medium': NCDealsMedium,
  'nc-deals-latest': NCDealsLatest,
  'nc-deals-medium-carousel': NCDealsMediumCarousel,
  // A guide pick's "Pin to compare" sat on these cards' photo 2026-09-16 → 2026-10-17, then its
  // strip stood under the card; since 2026-10-21 the strip is the card's footer on every
  // surface (`NCDealsLargeSG` — the shared A/B cards with their `footerSlot`; Android
  // Authority's cards are never edited for it). The review post's owner card (design 3a,
  // 2026-09-24 → 2026-10-21) is gone: its product card is this one.
  'nc-deals-large': NCDealsLargeSG,
  'nc-ad-classed': NCAdClassed,
  'nc-trust-us': NCTrustUs,
  'nc-about-expert': NCAboutExpert,
  'nc-best-list-section': NCBestListSection,
  'nc-linked-buttons': feed => (
    <NCLazy
      layout="raw"
      props={feed}
      component={NCLinkedButtons}
      className={clsx(styles.linkedButtonsLazy, styleUtils.nc)}
    />
  ),
  'nc-string': NCString,
  'nc-newsletter': feed => (
    <NCLazy
      layout="raw"
      component={NCNewsletter}
      props={feed}
      className={clsx({
        [styles.newsletterHomeLazy]: feed.tpl === 'home',
        [styles.newsletterLazy]: feed.tpl !== 'home',
      })}
    />
  ),
  'nc-poll': feed => (
    <NCPoll {...feed} requireLoginToShowResults={publicConfig('requireLoginToShowPollResults')} />
  ),
  'nc-more-posts': feed => (
    <NCLazy
      className={clsx(styleUtils.nc, styles.moreLazy, {
        [styles.moreLazyHome]: feed.tpl === 'home',
      })}
      component={NCMorePosts}
      props={feed}
      layout="raw"
    />
  ),
  'nc-section': NCSection,
  'nc-linked-img': NCLinkedImg,
  'nc-img': NCImg,
  'nc-alert': NCAlert,
  'nc-quote': NCQuote,
  'nc-see-also': NCSeeAlso,
  'nc-table': NCTable,
  'nc-embed-tiktok': feed => (
    <NCLazy
      className={clsx(styles.tiktokEmbed, styleUtils.nc)}
      layout="raw"
      component={NCEmbedTiktok}
      props={feed}
    />
  ),
  'nc-embed-youtube': feed => (
    <NCEmbedYoutube
      data={feed.data}
      index={feed.index}
      className={clsx(styles.videoLazy, styleUtils.mobileFull, styleUtils.nc)}
    />
  ),
  'nc-img-comparison': feed => (
    <NCLazy layout="responsive" ratio={feed.data.size} component={NCImgComparison} props={feed} />
  ),
  'nc-opinion': NCOpinion,
  'nc-gallery': NCGallery,
  'nc-carousel': feed => (
    <NCLazy
      layout="raw"
      component={NCCarousel}
      style={
        {
          '--w': feed.data.items[0].size?.w ?? 16,
          '--h': feed.data.items[0].size?.h ?? 9,
        } as CSSProperties
      }
      props={feed}
      className={clsx(styles.carouselLazy, styleUtils.nc, {
        [styles.carouselLazyTitled]: feed.data.title !== null,
      })}
    />
  ),
  'nc-tldr': NCTldr,
  'nc-ad': feed => (
    <NCAd
      {...feed}
      context={{
        getAds: async args => {
          const dataSource = await getds({ ts: args.ts })
          const { data: ads } = await dataSource.getAds(args.id, {
            type: args.type,
            postId: args.postId ?? undefined,
          })
          return ads
        },
      }}
    />
  ),
  // 'nc-ad': feed => (
  //   <NCLazy
  //     layout="raw"
  //     props={feed}
  //     component={NCAd}
  //     className={clsx(styles.adLazy, styles.containerLazy)}
  //   />
  // ),
  'nc-columns': NCColumns,
  'nc-tabs': NCTabs,
  'nc-pre': NCPre,
  'nc-script': NCScript,
  'nc-promoted': NCPromoted,
  'nc-multi': NCMulti,
  'nc-video': feed => (
    <NCLazy
      layout="raw"
      component={NCVideo}
      props={feed}
      className={clsx(styles.videoLazy, styleUtils.mobileFull, styleUtils.nc)}
    />
  ),
  'nc-audio-chart': NCAudioChart,
  'nc-audio-charts-next': NCAudioChartsNext,
  'nc-audio': feed => (
    <NCLazy
      layout="raw"
      component={NCAudio}
      props={feed}
      className={clsx(styles.audioLazy, styleUtils.nc)}
    />
  ),
  'nc-posts-list': feed => (
    <NCLazy
      layout="raw"
      component={NCPostsList}
      props={feed}
      className={clsx({
        [styles.postsListLargeLazy]: feed.data.size === 'large',
        [styles.postsListSmallLazy]: feed.data.size === 'small',
      })}
    />
  ),
  'nc-feedback': feed => (
    <NCLazy
      component={NCFeedback}
      props={feed}
      layout="raw"
      className={clsx(styleUtils.nc, styles.feedbackLazy)}
    />
  ),
  'nc-video-slider': feed => (
    <NCLazy
      component={NCVideoSlider}
      props={feed}
      layout="raw"
      className={clsx(styleUtils.nc, styles.moreLazyHome)}
    />
  ),
  'nc-expandable-img': NCExpandableImg,
}

const NC = componentMapper(map)

export default NC
